import { render, staticRenderFns } from "./DetailsSwiper.vue?vue&type=template&id=765970dd&scoped=true"
import script from "./DetailsSwiper.vue?vue&type=script&lang=js"
export * from "./DetailsSwiper.vue?vue&type=script&lang=js"
import style0 from "./DetailsSwiper.vue?vue&type=style&index=0&id=765970dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765970dd",
  null
  
)

export default component.exports